import { Routes, Route } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { MainLayout } from '@/components/layout/MainLayout';
import { ErrorPage } from '@/components/ErrorPage';
import { FeatureErrorBoundary } from '@/components/FeatureErrorBoundary';
import { AuthGuard } from '@/features/auth/components/AuthGuard';
import { Landing } from '@/pages/Landing';
import { Login } from '@/pages/Login';
import { Register } from '@/pages/Register';
import { Dashboard } from '@/pages/Dashboard';
import { Sources } from '@/pages/Sources';
import { Criteria } from '@/pages/Criteria';
import { Evaluate } from '@/pages/Evaluate';
import { Results } from '@/pages/Results';
import { Chat } from '@/pages/Chat';
import { Compare } from '@/pages/Compare';
import { Search } from '@/pages/Search';
import { Pricing } from '@/pages/Pricing';
import { Settings } from '@/pages/Settings';
import { Team } from '@/pages/Team';
import { Reports } from '@/pages/Reports';
import { Import } from '@/pages/Import';
import { Review as ReviewPage } from '@/pages/Review';
import { Screening } from '@/pages/Screening';
import { ForgotPassword } from '@/pages/ForgotPassword';
import { ResetPassword } from '@/pages/ResetPassword';
import { PrivacyPolicy } from '@/pages/PrivacyPolicy';
import { Terms } from '@/pages/Terms';
import { NotFound } from '@/pages/NotFound';

export function App() {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorPage />}>
    <Routes>
      <Route element={<MainLayout />}>
        {/* Public routes */}
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />

        {/* Protected routes */}
        <Route element={<AuthGuard />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/sources" element={<FeatureErrorBoundary featureName="Sources"><Sources /></FeatureErrorBoundary>} />
          <Route path="/criteria" element={<Criteria />} />
          <Route path="/evaluate" element={<FeatureErrorBoundary featureName="Evaluate"><Evaluate /></FeatureErrorBoundary>} />
          <Route path="/screening" element={<FeatureErrorBoundary featureName="Screening"><Screening /></FeatureErrorBoundary>} />
          <Route path="/results/:id" element={<Results />} />
          <Route path="/chat/:sourceId" element={<FeatureErrorBoundary featureName="Chat"><Chat /></FeatureErrorBoundary>} />
          <Route path="/compare" element={<Compare />} />
          <Route path="/search" element={<Search />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/team" element={<Team />} />
          <Route path="/review/:reviewId" element={<FeatureErrorBoundary featureName="Review"><ReviewPage /></FeatureErrorBoundary>} />
          <Route path="/reports" element={<FeatureErrorBoundary featureName="Reports"><Reports /></FeatureErrorBoundary>} />
          <Route path="/import" element={<Import />} />
        </Route>

        {/* Catch-all */}
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
    </Sentry.ErrorBoundary>
  );
}
